module.exports = __webpack_public_path__ + "img/rajesh_s.b67c1b89.png";